var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-lang"},[_c('span',{class:{ 'active-lang': _vm.currentLang === 'zh-CN' },on:{"click":function($event){return _vm.switchLang('zh-CN')}}},[_vm._v(" 中文 ")]),_vm._v(" / "),_c('span',{class:{ 'active-lang': _vm.currentLang === 'en' },on:{"click":function($event){return _vm.switchLang('en')}}},[_vm._v(" En ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }